/* STAAL / Google-reviews: de ring (09-10-2026, vijfde opzet)
   Hoort bij snippets/staal-google-reviews.liquid en assets/staal-gr.css.

   - De ring: de kaarten van de gekozen winkel staan rondom (hoek per kaart
     = 360 / aantal, straal zo dat ze net niet botsen). De draaiing A loopt
     met een veer naar een doel; slepen zet A direct en geeft bij loslaten
     vaart mee, daarna klikt hij vast op de dichtstbijzijnde kaart.
   - Per beeldje (alleen zolang hij draait): de transform van de ring en per
     kaart de opacity van kaart en sluier naar zijn hoek, rechtstreeks en
     alleen als die verandert. Allebei een eigen laag, dus niets wordt
     opnieuw getekend. Kaarten die helemaal weg zijn: visibility hidden.
     De voorste krijgt .is-voor (glans, sterren), de buren .is-zij
     (aanklikbaar).
   - Kantelen: de muis kantelt .gr-kantel een paar graden (CSS-overgang,
     geen veer).
   - Trackpad: twee vingers opzij draaien de ring mee (met de uitloop van
     het trackpad), daarna klikt hij vast. Twee vingers omhoog of omlaag
     scrollen gewoon de pagina; een gebaar kiest één richting en houdt die.
   - Rustig (de gebruiker: "iets te snel"): een zachte veer zonder
     doorschieten, ongeveer een seconde per kaart.
   - Vanzelf: elke 6 s een kaart verder zolang hij in beeld is, pas na de
     binnenkomst, en tot de eerste keer dat iemand zelf iets doet (ook een
     tik of klik ergens in het blok: dan draait hij niet weg terwijl je leest).
     Stil bij aanwijzen en met het venster open.
   - Winkel wisselen: de ring vervaagt, de kaarten van de andere winkel
     komen uit de diepte binnen (vanaf de voorste kaart naar buiten).
   - De binnenkomst speelt één keer (.is-in); terugscrollen doet niets.
   - "Lees de hele review" (alleen als de tekst echt afgekapt is) opent een
     venster met de kaart; een tik op de voorste kaart zelf ook.
   - Met "minder beweging" is er geen ring (CSS zet de kaarten naast
     elkaar); dan doet dit script alleen het venster en "Lees". */
(function () {
  'use strict';
  var stil = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var muis = !!(window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches);
  var lijst = function (x) { return Array.prototype.slice.call(x || []); };
  var norm = function (d) { d = ((d + 180) % 360 + 360) % 360 - 180; return d; };

  function init(gr) {
    if (gr.hasAttribute('data-gr-klaar')) return;
    gr.setAttribute('data-gr-klaar', '');
    var podium = gr.querySelector('[data-gr-podium]'), ring = gr.querySelector('[data-gr-ring]'), kantel = gr.querySelector('[data-gr-kantel]');
    var alle = lijst(gr.querySelectorAll('[data-gr-plek]'));
    var tabs = lijst(gr.querySelectorAll('[data-gr-winkel]'));
    var nuEl = gr.querySelector('[data-gr-nu]'), totEl = gr.querySelector('[data-gr-totaal]'), meld = gr.querySelector('[data-gr-meld]');
    var getal = gr.querySelector('[data-gr-getal]'), google = gr.querySelector('[data-gr-google]');
    var dlg = gr.querySelector('[data-gr-dlg]');
    if (!podium || !ring || !alle.length) return;

    var winkel = gr.getAttribute('data-winkel') || 'utrecht';
    var plekken = [], N = 1, hoek = 30, R = 600, kb = 340, A = 0, doel = 0, v = 0, raf = 0, voorNu = -1;
    var auto = false, autoTik = 0, zicht = false, wijst = false, binnen = false;
    var twee = function (n) { return (n < 10 ? '0' : '') + n; };
    /* kaarten achter in de ring zijn verborgen voor schermlezers (aria-hidden); hun knoppen mogen dan ook
       niet met Tab bereikbaar zijn. Bij minder beweging staan alle kaarten in beeld: dan alles bereikbaar. */
    var verberg = function (p, weg) {
      if (stil) { p.removeAttribute('aria-hidden'); return; }
      if (weg) p.setAttribute('aria-hidden', 'true'); else p.removeAttribute('aria-hidden');
      lijst(p.querySelectorAll('a[href], button')).forEach(function (e) { if (weg) e.setAttribute('tabindex', '-1'); else e.removeAttribute('tabindex'); });
    };

    /* de tekst stopt op een hele regel (met …): eerst de hele tekst meten, dan
       uitrekenen hoeveel regels er in de vrije ruimte passen. "Lees de hele
       review" alleen als er echt iets wegvalt. */
    /* Eerst alles klaarzetten, dan alles meten, dan alles zetten: per kaart
       schrijven-lezen-schrijven liet de browser voor elke kaart opnieuw de
       pagina opmeten (tot 20 keer bij het laden). Nu twee keer. 21-10-2026. */
    function meetLang() {
      var rij = [];
      plekken.forEach(function (p) {
        var t = p.querySelector('[data-gr-tekst]'), m = p.querySelector('[data-gr-meer]');
        if (t && m) rij.push({ t: t, m: m });
      });
      rij.forEach(function (x) { x.m.hidden = false; x.t.classList.add('is-meten'); });
      rij.forEach(function (x) {
        x.vrij = x.t.clientHeight; x.heel = x.t.scrollHeight;
        x.regel = parseFloat(getComputedStyle(x.t).lineHeight) || 23;
        x.lang = x.heel > x.vrij + 2;
      });
      var kort = rij.filter(function (x) { return !x.lang; });
      kort.forEach(function (x) { x.m.hidden = true; });
      kort.forEach(function (x) { x.vrij = x.t.clientHeight; x.lang = x.heel > x.vrij + 2; });
      rij.forEach(function (x) {
        if (!x.lang) x.m.hidden = true; else x.m.hidden = false;
        x.t.classList.remove('is-meten');
        x.t.style.setProperty('--regels', x.lang ? String(Math.max(2, Math.floor((x.vrij + 1) / x.regel))) : '99');
      });
    }
    /* De ring staat op elke pagina ver onder de vouw: de teksten pas meten als
       hij binnen een scherm afstand komt, niet midden in het laden. Daarna (bij
       een andere winkel, een nieuwe maat) meteen. */
    var gemeten = false, meetKijker = null;
    function meetZodraNodig() {
      if (gemeten || !('IntersectionObserver' in window)) { gemeten = true; meetLang(); return; }
      if (meetKijker) return;
      meetKijker = new IntersectionObserver(function (es) {
        if (!es.some(function (e) { return e.isIntersecting; })) return;
        meetKijker.disconnect(); meetKijker = null; gemeten = true; meetLang();
      }, { rootMargin: '100% 0px' });
      meetKijker.observe(gr);
    }

    /* de ring opbouwen voor de gekozen winkel */
    function bouw() {
      plekken = alle.filter(function (p) { return p.getAttribute('data-winkel') === winkel; });
      alle.forEach(function (p) { p.hidden = plekken.indexOf(p) < 0; });
      N = plekken.length;
      hoek = 360 / N;
      kb = plekken[0].offsetWidth || 340;   /* één keer meten; slepen leest dit, niet de pagina */
      var f = Math.max(1.02, parseFloat(getComputedStyle(gr).getPropertyValue('--ring-f')) || 1.12);   /* < 1 steken de kaarten door elkaar */
      R = Math.round((kb / 2) / Math.tan(Math.PI / N) * f + 24);
      ring.style.setProperty('--R', R + 'px');
      plekken.forEach(function (p, i) {
        p.style.setProperty('--a', (i * hoek).toFixed(3) + 'deg');
        p.style.setProperty('--R', R + 'px');
        var afstand = Math.min(i, N - i);
        p.style.setProperty('--d', afstand);   /* binnenkomen: eerst de voorste, dan naar buiten */
        p.toggleAttribute('data-dichtbij', afstand <= 1);   /* alleen wat je ziet vliegt binnen */
        p._k = p._k || p.querySelector('.gr-kaart');
        p._s = p._s || p.querySelector('.gr-sluier');
        p._o = p._zij = undefined;
      });
      if (totEl) totEl.textContent = twee(N);
      alle.forEach(function (p) { p.classList.remove('is-voor', 'is-zij'); verberg(p, true); });
      voorNu = -1;
      teken();
      meetZodraNodig();
    }

    function teken() {
      ring.style.transform = 'translateZ(' + (-R) + 'px) rotateY(' + (-A).toFixed(3) + 'deg)';
      var voor = ((Math.round(A / hoek) % N) + N) % N;
      plekken.forEach(function (p, i) {
        var d = Math.abs(norm(i * hoek - A));
        /* voorste en directe buren; wat verder draait (bijna op de kant) vervaagt helemaal, anders zie je dunne spookranden */
        var o = Math.round(Math.max(0, 1 - Math.pow(d / (hoek * 1.55), 3)) * 100) / 100;
        /* alleen schrijven wat echt verandert; de sluier groeit mee met de hoek (en vervaagt mee met de kaart) */
        if (o !== p._o) {
          if (p._o === undefined || !o !== !p._o) p.style.visibility = o ? '' : 'hidden';
          p._o = o;
          if (p._k) p._k.style.opacity = o;
          if (p._s) p._s.style.opacity = (o * Math.min(.62, (1 - o) * 1.6)).toFixed(2);
        }
        var zij = i !== voor && d < hoek * 1.6;
        if (zij !== p._zij) { p._zij = zij; p.classList.toggle('is-zij', zij); }
      });
      if (voor !== voorNu) {
        if (voorNu > -1 && plekken[voorNu]) { plekken[voorNu].classList.remove('is-voor'); verberg(plekken[voorNu], true); }
        voorNu = voor;
        var p = plekken[voor];
        p.classList.add('is-voor');   /* hij had de klas niet meer, dus glans en sterren spelen opnieuw (zonder de pagina te laten meten) */
        verberg(p, false);
        if (nuEl) nuEl.textContent = twee(voor + 1);
        /* voorlezen alleen als iemand zelf draait, niet elke 6 s vanzelf */
        if (meld && !auto) meld.textContent = 'Review ' + (voor + 1) + ' van ' + N + ': ' + (p.querySelector('.gr-kaart__wie b') || {}).textContent;
      }
    }

    /* een veer naar het doel */
    function draai() {
      if (raf) return;
      var vorige = performance.now();
      var stap = function (t) {
        var dt = Math.min(32, t - vorige) / 16.67; vorige = t;
        var kracht = (doel - A) * .011;
        v = (v + kracht * dt) * Math.pow(.8, dt);
        A += v * dt;
        teken();
        if (Math.abs(doel - A) < .02 && Math.abs(v) < .02) { A = doel; teken(); raf = 0; return; }
        raf = requestAnimationFrame(stap);
      };
      raf = requestAnimationFrame(stap);
    }
    function naar(i, zelf) {
      if (zelf) stopAuto();
      var huidig = Math.round(A / hoek);
      var stapjes = norm((i - huidig) * hoek) / hoek;
      doel = (huidig + Math.round(stapjes)) * hoek;
      if (stil) { A = doel; teken(); return; }
      draai();
    }
    function verder(n, zelf) { if (zelf) stopAuto(); doel = (Math.round(doel / hoek) + n) * hoek; if (stil) { A = doel; teken(); return; } draai(); }

    /* knoppen en toetsen */
    var terugK = gr.querySelector('[data-gr-terug]'), verderK = gr.querySelector('[data-gr-verder]');
    if (terugK) terugK.addEventListener('click', function () { verder(-1, true); });
    if (verderK) verderK.addEventListener('click', function () { verder(1, true); });
    podium.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); verder(1, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); verder(-1, true); }
    });

    /* slepen en vegen, met vaart */
    var sleep = null;
    podium.addEventListener('pointerdown', function (e) {
      if (stil || e.target.closest('a, button')) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      sleep = { id: e.pointerId, x: e.clientX, y: e.clientY, a0: A, actief: false, vx: 0, lx: e.clientX, lt: performance.now() };
    });
    podium.addEventListener('pointermove', function (e) {
      if (!sleep || e.pointerId !== sleep.id) return;
      var dx = e.clientX - sleep.x, dy = e.clientY - sleep.y;
      if (!sleep.actief) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        if (e.pointerType !== 'mouse' && Math.abs(dy) > Math.abs(dx)) { sleep = null; return; }   /* verticaal: de pagina scrolt */
        sleep.actief = true;
        stopAuto();
        cancelAnimationFrame(raf); raf = 0; v = 0;
        podium.classList.add('is-slepen');
        try { podium.setPointerCapture(e.pointerId); } catch (x) {}
      }
      var t = performance.now();
      A = sleep.a0 - dx * (hoek / kb) * 1.05;
      var dtm = Math.max(1, t - sleep.lt);
      sleep.vx = (e.clientX - sleep.lx) / dtm * .6 + sleep.vx * .4; sleep.lx = e.clientX; sleep.lt = t;
      doel = A;
      teken();
    });
    function los(e) {
      if (!sleep || (e && e.pointerId !== sleep.id)) return;
      var s = sleep; sleep = null;
      podium.classList.remove('is-slepen');
      if (!s.actief) return;
      podium._gesleept = performance.now();
      var worp = -s.vx * 180 * (hoek / kb);   /* vaart: hoe harder je gooit, hoe verder hij draait */
      doel = Math.round((A + worp) / hoek) * hoek;
      v = -s.vx * 6 * (hoek / kb);
      draai();
    }
    podium.addEventListener('pointerup', los);
    podium.addEventListener('pointercancel', los);

    /* tik op een buurkaart: daarheen draaien */
    podium.addEventListener('click', function (e) {
      if (podium._gesleept && performance.now() - podium._gesleept < 300) return;
      var p = e.target.closest('[data-gr-plek]');
      if (!p || e.target.closest('button, a')) return;
      if (p.classList.contains('is-zij')) { naar(plekken.indexOf(p), true); return; }
      /* de voorste kaart met afgekapte tekst: een tik op de kaart leest ook verder */
      var m = p.classList.contains('is-voor') && p.querySelector('[data-gr-meer]:not([hidden])');
      if (m) lees(m, false);
    });

    /* trackpad: twee vingers opzij */
    var wiel = { as: '', tik: 0, raf: 0, laatst: 0 };
    podium.addEventListener('wheel', function (e) {
      if (stil || e.ctrlKey) return;   /* ctrl: knijpen om te zoomen */
      var dx = e.deltaX, dy = e.deltaY;
      if (e.deltaMode === 1) { dx *= 16; dy *= 16; }
      if (!wiel.as) {
        if (Math.abs(dx) < 1.5 && Math.abs(dy) < 1.5) return;
        wiel.as = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (wiel.as === 'x') { stopAuto(); cancelAnimationFrame(raf); raf = 0; v = 0; }
      }
      clearTimeout(wiel.tik);
      wiel.tik = setTimeout(function () {   /* gebaar (en uitloop) voorbij: vastklikken, met een duwtje in de richting van de laatste beweging */
        var was = wiel.as; wiel.as = '';
        if (was !== 'x') return;
        doel = Math.round(A / hoek + (wiel.laatst > 0 ? .3 : wiel.laatst < 0 ? -.3 : 0)) * hoek;
        draai();
      }, 140);
      if (wiel.as !== 'x') return;
      e.preventDefault();   /* geen terug-gebaar van de browser */
      if (dx) wiel.laatst = dx;
      A += dx * (hoek / kb) * .9;
      doel = A;
      if (!wiel.raf) wiel.raf = requestAnimationFrame(function () { wiel.raf = 0; teken(); });
    }, { passive: false });

    /* kantelen met de muis */
    if (muis && !stil && kantel) {
      var kraf = 0, kx = 0, ky = 0;
      podium.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse' || sleep) return;
        var r = podium.getBoundingClientRect();
        kx = (e.clientX - r.left) / r.width - .5; ky = (e.clientY - r.top) / r.height - .5;
        if (!kraf) kraf = requestAnimationFrame(function () { kraf = 0; kantel.style.transform = 'rotateX(' + (ky * -7).toFixed(2) + 'deg) rotateY(' + (kx * 9).toFixed(2) + 'deg)'; });
      }, { passive: true });
      podium.addEventListener('pointerleave', function () { kantel.style.transform = ''; });
    }

    /* winkel wisselen */
    function kiesWinkel(w) {
      if (w === winkel) return;
      stopAuto();
      tabs.forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-gr-winkel') === w ? 'true' : 'false'); });
      gr.setAttribute('data-winkel', w);
      if (google) google.href = google.getAttribute('data-' + w);
      var wissel = function () {
        winkel = w;
        cancelAnimationFrame(raf); raf = 0;
        A = 0; doel = 0; v = 0;
        bouw();
        podium.classList.remove('is-weg');
      };
      if (stil) { wissel(); return; }
      podium.classList.add('is-weg');
      setTimeout(wissel, 300);
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { kiesWinkel(t.getAttribute('data-gr-winkel')); }); });

    /* vanzelf */
    function plan() {
      clearTimeout(autoTik);
      if (!auto) return;
      autoTik = setTimeout(function () {
        if (!auto) return;
        if (zicht && !wijst && !(dlg && dlg.open) && !sleep) verder(1, false);
        plan();
      }, 6000);
    }
    function stopAuto() { auto = false; clearTimeout(autoTik); }
    gr.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') wijst = true; });
    gr.addEventListener('pointerdown', stopAuto, { passive: true });
    gr.addEventListener('pointerleave', function () { wijst = false; });

    /* de hele review */
    function lees(m, toets) {
      if (!dlg) return;
      stopAuto();
      var inhoud = dlg.querySelector('[data-gr-dlg-inhoud]');
      var kopie = m.closest('.gr-kaart').cloneNode(true);
      kopie.removeAttribute('style');
      inhoud.textContent = '';
      inhoud.appendChild(kopie);
      dlg._knop = m;
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      dlg.scrollTop = 0;
      /* met muis of vinger: focus op het venster zelf (geen rand om het kruisje); met het toetsenbord op het kruisje */
      var focusOp = toets ? dlg.querySelector('[data-gr-sluit]') : dlg.querySelector('[data-gr-dlg-kaart]');
      if (focusOp) focusOp.focus({ preventScroll: true });
    }
    if (dlg) {
      gr.addEventListener('click', function (e) {
        var m = e.target.closest('[data-gr-meer]');
        if (m) lees(m, e.detail === 0);   /* detail 0: geklikt met Enter of spatie */
      });
      dlg.querySelector('[data-gr-sluit]').addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      dlg.addEventListener('close', function () { if (dlg._knop) dlg._knop.focus({ preventScroll: true }); });
    }

    bouw();
    (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(function () { if (gemeten) meetLang(); });
    window.addEventListener('resize', function () { clearTimeout(gr._rt); gr._rt = setTimeout(bouw, 160); }, { passive: true });

    /* in beeld: cijfer telt op, ring gaat vanzelf draaien */
    function binnenkomen() {
      if (binnen) return;
      binnen = true;
      gr.classList.add('is-in');
      if (stil || !getal) return;
      var tekst = getal.textContent, doelG = parseFloat(tekst.replace(',', '.')) || 5, t0 = null;
      getal.textContent = '0,0';
      setTimeout(function () {
        requestAnimationFrame(function stap(t) {
          if (t0 === null) t0 = t;
          var p = Math.min(1, (t - t0) / 1400), e = 1 - Math.pow(1 - p, 3);
          getal.textContent = (doelG * e).toFixed(1).replace('.', ',');
          if (p < 1) requestAnimationFrame(stap); else getal.textContent = tekst;
        });
      }, 600);
      setTimeout(function () { auto = true; plan(); }, 2600);
    }
    if (!('IntersectionObserver' in window)) { binnenkomen(); return; }
    /* profielfoto's: Safari laadt "lazy" plaatjes in de ring pas als die kaart naar voren draait (even een leeg
       rondje). Zodra het blok in de buurt komt laden ze daarom allemaal, ook die van de andere winkel (samen ± 30 kB). */
    var fotos = new IntersectionObserver(function (l) {
      if (!l[0].isIntersecting) return;
      fotos.disconnect();
      lijst(gr.querySelectorAll('.gr-av img[loading="lazy"]')).forEach(function (i) { i.loading = 'eager'; });
    }, { rootMargin: '900px 0px' });
    fotos.observe(gr);
    new IntersectionObserver(function (l) {
      zicht = l[0].intersectionRatio >= .35;
      if (l[0].isIntersecting && l[0].intersectionRatio >= .2) binnenkomen();
    }, { threshold: [0, .2, .35, .6] }).observe(gr);
  }

  function boot() { lijst(document.querySelectorAll('[data-gr]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
